import consumer from "./consumer";

window.subscribeToDocumentsChannel = function (currentUserId) {
    const identifier = JSON.stringify({channel: "DocumentsChannel", user_id: currentUserId});
    if (!consumer.subscriptions.findAll(identifier).length) {
        consumer.subscriptions.create({channel: "DocumentsChannel", user_id: currentUserId}, {

                connected() {
                    // Called when the subscription is ready for use on the server
                    console.log("connected to DocumentsChannel" + currentUserId)
                    var feedbackElement = $("#docs-process-feedback");
                },

                disconnected() {
                    // Called when the subscription has been terminated by the server
                },

                received(data) {
                    // Called when there's incoming data on the websocket for this channel
                    if (data.progress) {
                        const feedbackElement = $("#docs-process-feedback");
                        feedbackElement.removeClass("d-none");

                        feedbackElement.append('<br>' + data.progress);
                        
                        feedbackElement.scrollTop(feedbackElement[0].scrollHeight);
                    }

                    if (data.error) {
                        const feedbackElement = $("#docs-process-feedback");
                        feedbackElement.removeClass("d-none");

                        feedbackElement.append('<br>' + data.error);
                        
                        feedbackElement.scrollTop(feedbackElement[0].scrollHeight);
                    }
                }
            }
        );
    }
}